<template>
    <div class="home">

        <div id="box">
            <!--                <div style="width: 100%; height: 110px; background-color:#f7f7f7">-->

            <Nav2></Nav2>
            <!--                </div>-->
            <StarDemo></StarDemo>
            <!--        <div class="hidden"></div>-->
            <div>
                <section class="banner" id="one">
                    <index></index>
                </section>

                <!--            <section class="banner" id="two">-->
                <!--&lt;!&ndash;                <index></index>&ndash;&gt;-->
                <!--            </section>-->
                <!--            <section class="banner" id="two">-->
                <!--            </section>-->
                <!--            <section class="banner" id="three">-->
                <!--            </section>-->


            </div>
            <Foot2></Foot2>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import Nav2 from '../../../components/v2/Nav2'
    // import Foot2 from "../../../components/v2/Foot2";
    // import StarDemo from "../../../components/v2/StarDemo";
    // import index from "../../../components/v2/credit_project/index"
    const Nav2 = () => import('../../../components/v2/Nav2');
    const Foot2 = () => import('../../../components/v2/Foot2');
    const StarDemo = () => import('../../../components/v2/StarDemo');
    const index = () => import('../../../components/v2/credit_project/index');
    export default {
        name: 'Homev2',

        components: {
            Nav2,
            Foot2,
            StarDemo,
            index
        },
        methods: {
            scroll: function (page) {
                document.getElementById(page).scrollIntoView({behavior: 'smooth'})
                // this.currentPage = page

            },
        },
        mounted() {
            this.scroll('one')
        }

    }
</script>
<style scoped>
    * {
        box-sizing: border-box;
        font-family: "Microsoft YaHei", 微软雅黑;
    }

    #box {
        margin-left: auto;
        margin-right: auto;
        /*min-width: 1200px;*/
        /*background-color: #8cc5ff;*/
    }

    .home {
        background: radial-gradient(200% 100% at bottom center, #f7f7b6, #e96f92);
        background: radial-gradient(220% 105% at top center, #1b2947 20%, #75517d 60%, #e96f92 95%, #f7f7b6);
        position: relative;
        /*position: fixed;*/
        width: 100%;
        /*height: 300vh;*/

        overflow: hidden;
    }


    .banner {
        /*width: 1200px;*/
        height: 200vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Consolas;
        opacity: 0.9;
    }


</style>